export var NoteTypeGroup;
(function (NoteTypeGroup) {
    NoteTypeGroup["GENERAL"] = "GENERAL";
    NoteTypeGroup["ACCOMMODATION"] = "ACCOMMODATION";
    NoteTypeGroup["SPA"] = "SPA";
    NoteTypeGroup["RESTAURANT"] = "RESTAURANT";
    NoteTypeGroup["BILLING"] = "BILLING";
    NoteTypeGroup["CRM"] = "CRM";
    NoteTypeGroup["MARKETING"] = "MARKETING";
})(NoteTypeGroup || (NoteTypeGroup = {}));
